import styled from '@emotion/styled'

import { Color, theme } from '../../../constants'
import { Flex, Icon, Text } from '../../../elements'

const TimeInput = styled.input({
  fontSize: theme.font.size[5],
  fontWeight: theme.font.weight.bold,
  border: 'none',
  width: 'max-content',
  textAlign: 'center',
  background: 'transparent',
  color: 'inherit',

  '::-webkit-calendar-picker-indicator': {
    display: 'none',
  },
})

type ExactTimeInputProps = {
  startTime: string
  endTime: string
  onStartTimeChange: (time: string) => void
  onEndTimeChange: (time: string) => void
  onBlur: () => void
}

export const ExactTimeInput = (props: ExactTimeInputProps) => {
  return (
    <Flex
      gap={2}
      items="center"
      styles={{
        gridColumn: '2 / 5',
        borderRadius: theme.border.radius.small,
        justifyContent: 'center',
        background: Color.LIGHTER_GREEN,
        color: Color.DARKEST_GREEN,
      }}
    >
      <Icon
        name="CalendarIcon"
        color={Color.DARKEST_GREEN}
        design="solid"
        styles={{
          mr: 2,
        }}
      />

      <TimeInput
        type="time"
        value={props.startTime}
        onChange={(e) => props.onStartTimeChange(e.target.value)}
        onBlur={props.onBlur}
      />
      <Text>-</Text>
      <TimeInput
        type="time"
        value={props.endTime}
        onChange={(e) => props.onEndTimeChange(e.target.value)}
        onBlur={props.onBlur}
      />
    </Flex>
  )
}
